import './footer.css'

const Footer = () => {

      return (
            <div className="footer_content">
                  <p>Theme - xatme.com - JasonOfical 1202</p>
            </div>
      )
}

export default Footer
